import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperclip } from '@fortawesome/pro-solid-svg-icons';
import AttachmentChip from 'components/attachments/chip';

export default function Attachments({ attachments }) {
  if (!attachments || attachments.length === 0) {
    return null;
  }

  return (
    <div className="d-flex flex-column mt-4 py-1 gap-4 border-dotted">
      <div>
        <span>
          <FontAwesomeIcon className="me-2" icon={faPaperclip} />
          {attachments.length} Attachments
        </span>
      </div>
      <div className="d-flex gap-3 flex-wrap">
        {attachments.map(attachment => (
          <AttachmentChip key={attachment.id} {...attachment} />
        ))}
      </div>
    </div>
  );
}

Attachments.propTypes = {
  attachments: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.number.isRequired }),
  ),
};
